import React from 'react';

import { MarketCard } from '@eika/card';

import { StringKeyValue } from '../../../actions/types';
import { getAssetByName } from '../../../assets';
import customHistory from '../../../customHistory';
import LoanProductName from '../../../util/mappings/loanProductName';
import RoutePath from '../../../util/mappings/routePath';

interface Props {
    text: StringKeyValue;
}

type ProductList = {
    id: string;
    title: string;
    description: string;
    icon: string;
    link: string;
    linkText: string;
}[];

const VehicleTypeSelector = ({ text }: Props): JSX.Element => {
    const productList: ProductList = [
        {
            id: 'car',
            title: LoanProductName.car,
            description: text.vehicleTypeSelectorDescriptionCar,
            icon: getAssetByName('SecuredLoanCar'),
            link: RoutePath.calculatorCar,
            linkText: 'Velg',
        },
        {
            id: 'car_electric',
            title: LoanProductName.carElectric,
            description: text.vehicleTypeSelectorDescriptionCarElectric,
            icon: getAssetByName('SecuredLoanCarElectric'),
            link: RoutePath.calculatorCarElectric,
            linkText: 'Velg',
        },
        {
            id: 'car_no_insurance',
            title: LoanProductName.carNoInsurance,
            description: text.vehicleTypeSelectorDescriptionCarNoInsurance,
            icon: getAssetByName('SecuredLoanCarNoInsurance'),
            link: RoutePath.calculatorCarNoInsurance,
            linkText: 'Velg',
        },
        {
            id: 'mc',
            title: LoanProductName.mc,
            description: text.vehicleTypeSelectorDescriptionMC,
            icon: getAssetByName('SecuredLoanMC'),
            link: RoutePath.calculatorMC,
            linkText: 'Velg',
        },
        {
            id: 'atv',
            title: LoanProductName.atv,
            description: text.vehicleTypeSelectorDescriptionATV,
            icon: getAssetByName('SecuredLoanATV'),
            link: RoutePath.calculatorATV,
            linkText: 'Velg',
        },
        {
            id: 'snowmobile',
            title: LoanProductName.snowmobile,
            description: text.vehicleTypeSelectorDescriptionSnowmobile,
            icon: getAssetByName('SecuredLoanSnowmobile'),
            link: RoutePath.calculatorSnowmobile,
            linkText: 'Velg',
        },
        {
            id: 'camping',
            title: LoanProductName.campingCar,
            description: text.vehicleTypeSelectorDescriptionCampingCar,
            icon: getAssetByName('SecuredLoanCampingCar'),
            link: RoutePath.calculatorCampingCar,
            linkText: 'Velg',
        },
        {
            id: 'caravan',
            title: LoanProductName.campingCaravan,
            description: text.vehicleTypeSelectorDescriptionCampingCaravan,
            icon: getAssetByName('SecuredLoanCampingCaravan'),
            link: RoutePath.calculatorCampingCaravan,
            linkText: 'Velg',
        },
        /*
        {
            id: 'boat',
            title: LoanProductName.boat,
            description: text.vehicleTypeSelectorDescriptionBoat,
            icon: getAssetByName('SecuredLoanBoat'),
            link: RoutePath.calculatorBoat,
            linkText: 'Velg',
        },
        */
    ];

    return (
        <div className="vehicle-type-selector">
            <div className="vehicle-type-selector-title" style={{ maxWidth: '1200px', margin: '0 auto' }}>
                <h1>{text.vehicleTypeSelectorMainTitle}</h1>
                <p>{text.vehicleTypeSelectorTitle}</p>
            </div>

            <div className="sgw-layout">
                {productList.map((p) => (
                    <MarketCard
                        key={p.id}
                        className="sgw-layout-item"
                        title={p.title}
                        style={{ margin: 0, marginBottom: '24px' }}
                        header={
                            <MarketCard.IllustrationHeader
                                image={{
                                    src: p.icon,
                                    alt: p.title,
                                }}
                            />
                        }
                        primaryButton={
                            <MarketCard.PrimaryButton onClick={() => customHistory.push(p.link)}>
                                {p.linkText}
                            </MarketCard.PrimaryButton>
                        }
                    >
                        <p>{p.description}</p>
                    </MarketCard>
                ))}
            </div>
        </div>
    );
};

export default VehicleTypeSelector;
